import { render, staticRenderFns } from "./LockedIcon.vue?vue&type=template&id=61ad5e4f"
import script from "./LockedIcon.vue?vue&type=script&lang=ts"
export * from "./LockedIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports